export const DECLARE = "declare";
export const REROLL = "reroll";
export const KEEP = "keep";
export const RESOLVE = "resolve";
